import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { capacityQueryKeys } from 'src/lib/query-keys/capacity';
import { TeamRolesApi } from '@/lib/api/team-roles';
import type { TeamRole } from '@/lib/api/types/teamRoles';

export const getTeamRolesQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.teamRoles.all(),
    queryFn: async () => {
      const roles = await TeamRolesApi.getTeamRoles();
      return Array.isArray(roles) ? roles.sort((a, b) => a.name.localeCompare(b.name)) : [];
    },
  };
};

export const useTeamRolesQuery = (options: Partial<UseQueryOptions<TeamRole[]>> = {}) => {
  return useQuery({ ...getTeamRolesQueryOptions(), ...options });
};
